import { render } from "./ClassMatesDetails.vue?vue&type=template&id=3d82c1f8"
import script from "./ClassMatesDetails.vue?vue&type=script&lang=js"
export * from "./ClassMatesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__